import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form/form";
import { Input } from "@/components/ui/input/input";
import { HelperButton } from "@/components/ui/helper-button/helper-button";
import { Textarea } from "@/components/ui/textarea/textarea";

import { FormValues } from "../../page";

export const EmployeeAddressContacts = () => {
  const form = useFormContext<FormValues>();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Phone
              <HelperButton>
                <p>Phone number of the Employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="text" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="emergencyContactNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Emergency Contact Number
              <HelperButton>
                <p>Emergency contact number for the employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="text" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Address
              <HelperButton>
                <p>Address of Employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Textarea rows={5} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
